import {
  GetIntegrationAppRequest,
  GetIntegrationCompanyRequest,
  GetIntegrationConfigListRequest,
  GetIntegrationRecordTypeRequest,
} from '@trukt/tms-api/integration-service';
import { createKey } from './createKey';

const keyHandler = createKey('integration');

export const IntegrationServiceKeys = {
  key: keyHandler.key,
  getAppList: keyHandler.createMethod<GetIntegrationAppRequest>(),
  getCompanyList: keyHandler.createMethod<GetIntegrationCompanyRequest>(),
  getRecordTypeList: keyHandler.createMethod<GetIntegrationRecordTypeRequest>(),
  getAppConfigs: keyHandler.createMethod<GetIntegrationConfigListRequest>(),
};
